import { render, staticRenderFns } from "./RewardDetail.vue?vue&type=template&id=4179bf8c&scoped=true&"
import script from "./RewardDetail.vue?vue&type=script&lang=js&"
export * from "./RewardDetail.vue?vue&type=script&lang=js&"
import style0 from "./RewardDetail.vue?vue&type=style&index=0&id=4179bf8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4179bf8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4179bf8c')) {
      api.createRecord('4179bf8c', component.options)
    } else {
      api.reload('4179bf8c', component.options)
    }
    module.hot.accept("./RewardDetail.vue?vue&type=template&id=4179bf8c&scoped=true&", function () {
      api.rerender('4179bf8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Stamp/components/RewardDetail.vue"
export default component.exports